class CtxStore {
  constructor() {
    this.bindActions(this.alt.getActions('Ctx'));

    this.config = {};
    this.location = {};
    this.page = {};
    this.errors = {};
  }

  onUpdate({ config, location, page }) {
    if (config) {
      this.config = config;
    }

    if (location) {
      this.location = location;
    }

    if (page) {
      this.page = page;
    }
  }
}

export default CtxStore;



// WEBPACK FOOTER //
// ./app/flux/stores/Ctx.js